<template>
    <editor-field-frame :label="props.label" :hint="props.hint" :control-id="controlId">
        <template #default="{controlId: id, hintId}">
            <div class="d-flex align-center" style="gap: 12px;">
                <!--
                    Farbwert als Text: eingebbar, vorlesbar und kopierbar.
                    Der Picker liegt in einem Menü, damit ein einzelnes
                    Farbfeld nicht die halbe Formularhöhe belegt.
                -->
                <!-- i18n-ignore: Der Platzhalter ist ein Farbformat, kein Text -->
                <v-text-field placeholder="#RRGGBB"
                              v-model="hexValue"
                              :id="id"
                              :aria-describedby="hintId"
                              variant="outlined"
                              density="comfortable"
                              hide-details
                              style="max-width: 200px;" />

                <v-menu :close-on-content-click="false">
                    <template v-slot:activator="{props: menuProps}">
                        <v-btn v-bind="menuProps"
                               variant="outlined"
                               class="normal-case"
                               prepend-icon="mdi-eyedropper-variant">{{ $t('editor.fields.color.pick') }}</v-btn>
                    </template>
                    <v-card>
                        <v-color-picker v-model="hexValue"
                                        mode="hex"
                                        :modes="['hex']"
                                        :elevation="0" />
                    </v-card>
                </v-menu>

                <!-- Sichtbare Kontrolle des gewählten Werts -->
                <div class="editor-color-swatch" :style="{backgroundColor: swatch}"
                     :title="hexValue || $t('editor.fields.color.none')"></div>
            </div>
        </template>
    </editor-field-frame>
</template>

<script setup>
import {computed} from "vue";
import EditorFieldFrame from "./EditorFieldFrame.vue";
import {mandatory_props, useEditorField, editorControlId} from "../../utils/editorConfigFieldHelpers";

const props = defineProps(mandatory_props);
const {value, jsonPath} = useEditorField(props);

const controlId = computed(() => editorControlId('color', jsonPath.value));

const hexValue = computed({
    get() {
        return value.value ?? null;
    },
    set(v) {
        if (typeof v !== 'string') {
            value.value = v;
            return;
        }

        // Der Picker liefert gelegentlich "#FFAABBNAN" - auf 7 Zeichen kürzen.
        value.value = v.length >= 7 ? v.substring(0, 7) : v;
    }
});

const swatch = computed(() => {
    const v = hexValue.value;

    return (typeof v === 'string' && /^#[0-9a-f]{3,8}$/i.test(v)) ? v : 'transparent';
});
</script>

<style scoped>
.editor-color-swatch {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    border: 1px solid var(--editor-border-color);
    flex: 0 0 auto;
}
</style>
